import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <Link to="/" className="inline-flex items-center gap-2 text-primary hover:text-primary/80 mb-6">
          <ArrowLeft className="w-4 h-4" />
          Back to Home
        </Link>

        <Card className="border-border">
          <CardHeader>
            <CardTitle className="text-3xl font-bold text-[#E5B33E]" style={{ fontFamily: 'Manrope' }}>
              Terms of Service
            </CardTitle>
            <p className="text-sm text-muted-foreground">Last Updated: January 28, 2025</p>
          </CardHeader>
          <CardContent className="prose prose-invert max-w-none space-y-6">
            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">1. Acceptance of Terms</h2>
              <p className="text-muted-foreground">
                By accessing and using MudraFX ("the Service"), you accept and agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use the Service.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">2. Description of Service</h2>
              <p className="text-muted-foreground">
                MudraFX provides currency conversion services, historical exchange rate data, and related financial information tools. The Service is provided "as is" and "as available" without any warranties of any kind.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">3. User Responsibilities</h2>
              <p className="text-muted-foreground mb-2">You agree to:</p>
              <ul className="list-disc pl-6 text-muted-foreground space-y-2">
                <li>Use the Service only for lawful purposes</li>
                <li>Not attempt to interfere with the proper functioning of the Service</li>
                <li>Not attempt to access unauthorized areas of the Service</li>
                <li>Not use the Service to transmit malicious code or harmful content</li>
                <li>Verify all currency conversion data independently before making financial decisions</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">4. Intellectual Property</h2>
              <p className="text-muted-foreground">
                All content, features, and functionality of MudraFX, including but not limited to text, graphics, logos, and software, are owned by MudraFX or its licensors and are protected by international copyright, trademark, and other intellectual property laws.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">5. Data Accuracy and Reliability</h2>
              <p className="text-muted-foreground">
                While we strive to provide accurate and up-to-date exchange rates, we cannot guarantee the accuracy, completeness, or reliability of the data. Exchange rates are sourced from third-party providers (ExchangeRate-API and Frankfurter API) and may be subject to delays or inaccuracies.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">6. Limitation of Liability</h2>
              <p className="text-muted-foreground">
                To the fullest extent permitted by law, MudraFX and its developers shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, or any loss of data, use, goodwill, or other intangible losses resulting from:
              </p>
              <ul className="list-disc pl-6 text-muted-foreground space-y-2 mt-2">
                <li>Your use or inability to use the Service</li>
                <li>Any inaccuracies in exchange rate data</li>
                <li>Financial decisions made based on information from the Service</li>
                <li>Unauthorized access to or alteration of your data</li>
                <li>Any other matter relating to the Service</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">7. Disclaimer of Warranties</h2>
              <p className="text-muted-foreground">
                THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. WE DO NOT WARRANT THAT THE SERVICE WILL BE UNINTERRUPTED, SECURE, OR ERROR-FREE.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">8. Third-Party Services</h2>
              <p className="text-muted-foreground">
                The Service relies on third-party APIs for exchange rate data. We are not responsible for the accuracy, availability, or performance of these third-party services. Any issues with third-party services are beyond our control.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">9. Modifications to Service</h2>
              <p className="text-muted-foreground">
                We reserve the right to modify, suspend, or discontinue any part of the Service at any time without notice. We shall not be liable to you or any third party for any modification, suspension, or discontinuation of the Service.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">10. Termination</h2>
              <p className="text-muted-foreground">
                We may terminate or suspend your access to the Service immediately, without prior notice or liability, for any reason, including if you breach these Terms of Service.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">11. Governing Law</h2>
              <p className="text-muted-foreground">
                These Terms shall be governed by and construed in accordance with the laws of India, without regard to its conflict of law provisions. Any disputes arising from these Terms shall be subject to the exclusive jurisdiction of the courts in India.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">12. Changes to Terms</h2>
              <p className="text-muted-foreground">
                We reserve the right to update or modify these Terms at any time. Your continued use of the Service after any changes constitutes acceptance of the new Terms.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">13. Contact Information</h2>
              <p className="text-muted-foreground">
                For questions about these Terms of Service, please contact us at:
              </p>
              <p className="text-primary mt-2">
                Email: <a href="mailto:support@mudrafx.app" className="hover:underline">support@mudrafx.app</a>
              </p>
            </section>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}